import React from 'react';
import { Box, Grid, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useFormContext } from 'react-hook-form';
// Import our new common layout library
import FormSelect, {
  FormInput,
  FormDatepicker,
  FormAutocomplete,
  FormMultiSelect,
  FormAutocompleteMultiSelect,
} from './FormControls';
import useSupplierAutofill from '../hooks/useSupplierAutofill';
import SupplierField from './SupplierField';

const Purchase = ({ values }) => {
  // Dynamically contextually fetch watch without passing props
  const { watch } = useFormContext();

  useSupplierAutofill(values.supplierList);

  const type = watch('type');
  const currentType = Array.isArray(type) ? type : [type];
  const showToolAssignedTo = ['Tools', 'Tyres', 'Spare Tyre', 'Other'].some(t => currentType.includes(t));

  return (
    <Box sx={{ width: '100%' }}>
      {/* ─── BASIC INFO ─── */}
      <Accordion defaultExpanded sx={{ mb: 2 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" fontWeight="bold">
            Basic Info
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <FormDatepicker name="submissionDate" label="Date" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormInput name="requestorEmail" label="Requestor Email" placeholder="Enter Email" />
            </Grid>
              <SupplierField supplierList={values.supplierList || []} />
            <Grid item xs={12} sm={4}>
              <FormInput name="emailToSupplier" label="Supplier Email" placeholder="Enter Supplier Email" />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* ─── REQUEST INFO ─── */}
      {console.log("values['machineData']", values['machineData'])}
      <Accordion defaultExpanded sx={{ mb: 2 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" fontWeight="bold">
            Request Info
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <FormAutocompleteMultiSelect
                name="departmentMachine"
                label="Department / Machine"
                data={values?.departmentList || []}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormInput name="emailAddresses" label="Email Addresses For Email" placeholder="Enter Email" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormInput
                name="totalNetValue"
                label="Total Net Value"
                placeholder="Total Value"
                type="number"
                inputProps={{ step: '0.01', min: 0 }}
              />
            </Grid>
            
            {console.log('TYPE VALUE ===', values['Type'])}
            <Grid item xs={12} sm={4}>
              <FormSelect name="type" label="Type" options={values['Type']} />
            </Grid>

            {showToolAssignedTo && (
              <Grid item xs={12} sm={4}>
                <FormInput
                  name="toolsAssignedTo"
                  label={type === 'Other' ? 'Other' : 'Tools Assigned To'}
                  placeholder={type === 'Other' ? 'Enter other option' : 'Enter name'}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={12}>
              <FormInput
                name="description"
                label="Description"
                placeholder="Enter description"
                multiline
                minRows={4}
                maxRows={10}
                required
              />
            </Grid>
          </Grid>
          
        </AccordionDetails>
      </Accordion>

      {/* ─── WARRANTY DETAILS ─── */}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" fontWeight="bold">
            Warranty Details
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <FormSelect name="warrantyPeriod" label="Warranty Period" options={values['WarrantyPeriod']} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormInput name="whPartRefNumber" label="WH Part Ref Number" placeholder="Enter WH Part Ref" type="number" />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormInput
                name="supplierPartRefNumber"
                label="Supplier Part Ref Number"
                placeholder="Enter Supplier Part Ref"
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default Purchase;
